import $ from 'jquery';
// 分片大小
const fileShardSize = 100 * 1024;
export default {
  data(){
    return{
      waitUploadFiles: [],
      waitImageId: [],
      types:[],
      uploadParam: {}, //必须的
      action: "", //上传后台路径

    }
  },
  methods:{
    /**
     * 上传附件
     * */
    uploadFiles(files){
      let types = this.type;
      let names = [];
      //逐个列出需要传递的参数
      let postFiles = Array.prototype.slice.call(files);
      if(types && types.length > 0) {
        postFiles.forEach(file => {
          let fileName = file.name;
          let fileNames = fileName.split(".");
          let suffix = fileNames[fileNames.length - 1].toLowerCase();
          let exist = false;
          for(let n = 0; n < types.length; n++) {
            if(types[n].toLowerCase() === suffix) {
              exist = true;
              break;
            }
          }
          if(!exist) {
            names.push(fileName);
          }
          else {
            let id = this.uploadParam.fileBusinessId+""+new Date().getTime()+""+parseInt(10000000*Math.random());
            let size = file.size;
            let shardCount = Math.ceil(size / fileShardSize);
            let data = "";
            this.waitUploadFiles.push({id: id, index: 1, total: shardCount, progress:0, file: file, status: 'waitting', data: data});
            if(this.format(file.name) === "ios-image") {
              this.waitImageId.push(id);
            }
            // 检查是否有数据在上传
            if(this.waitUploadFiles[0].status === 'waitting') {
              this.upload();
            }
          }
        });

        if(this.waitImageId.length > 0) {
          this.showImg();
        }
      }else{
        postFiles.forEach(file => {
          let id = this.uploadParam.fileBusinessId+""+new Date().getTime()+""+parseInt(10000000*Math.random());
          let size = file.size;
          let shardCount = Math.ceil(size / fileShardSize);
          let data = "";
          this.waitUploadFiles.push({id: id, index: 1, total: shardCount, progress:0, file: file, status: 'waitting', data: data});
          if(this.format(file.name) === "ios-image") {
            this.waitImageId.push(id);
          }

          // 检查是否有数据在上传
          if(this.waitUploadFiles[0].status === 'waitting') {
            this.upload();
          }
          if(this.waitImageId.length > 0) {
            this.showImg();
          }
        });
      }
    },
    showImg() {
      if(this.waitImageId.length === 0) {
        return ;
      }
      let firstIndex = 0;
      for(let m = 0; m < this.waitUploadFiles.length; m++) {
        if(this.waitUploadFiles[m].id === this.waitImageId[0]) {
          firstIndex = m;
          break;
        }
      }
      let that = this;
      let reader=new FileReader();
      reader.readAsDataURL(this.waitUploadFiles[firstIndex].file);
      reader.onload=function(){
        if(that.waitImageId.length === 0) {
          return ;
        }
        let imgData = reader.result;
        that.waitImageId.splice(0, 1);
        that.waitUploadFiles[firstIndex].data = imgData;
        that.showImg();
      }
    },
    /**
     * 与服务器的交互
     * */
    upload() {
      if (this.waitUploadFiles.length > 0) {
        this.waitUploadFiles[0].status = "uploading";
        let start = (this.waitUploadFiles[0].index - 1) * fileShardSize,
          end = Math.min(this.waitUploadFiles[0].file.size, start + fileShardSize);
        let formData = this.jsonParamToFormData(this.uploadParam);
        formData.append("fileName", this.waitUploadFiles[0].file.name);
        formData.append("file", this.waitUploadFiles[0].file.slice(start,end));
        formData.append("dataAttacheId", this.waitUploadFiles[0].id);
        formData.append("index", this.waitUploadFiles[0].index);
        formData.append("total", this.waitUploadFiles[0].total);
        formData.append("sliceSize", fileShardSize);
        let startTime = new Date().getTime();
        let that = this;
        let url = this.action;
        console.log(url);
        $.ajax({
          url: this.action,
          type: "POST",
          data: formData,
          processData: false,  //很重要，告诉jquery不要对form进行处理
          contentType: false,  //很重要，指定为false才能形成正确的Content-Type
          dataType: 'json',
          success: function (data) {
            let endTime = new Date().getTime();
            let nextIndex = that.waitUploadFiles[0].index + 1;
            let progress = Math.ceil(that.waitUploadFiles[0].index * 100.0 / that.waitUploadFiles[0].total);
            let speedDw = "KB/S";
            let speed = (((end - start) / 1024.0) / ((endTime - startTime) / 1000.0)).toFixed(1);
            if (speed > 1024) {
              speed = (speed / 1024.0).toFixed(2);
              speedDw = "M/S";
            }
            // console.log(that.waitUploadFiles[0].file.name+"upload index=" + that.waitUploadFiles[0].index+"--progress:"+progress);
            // 已传完当前文件
            let res = JSON.parse(JSON.stringify(data))
            if (nextIndex > that.waitUploadFiles[0].total) {
              that.waitUploadFiles.shift();
              that.uploadAfterLogic(res.data.file);
            }
            // 当前文件未传完
            else {
              that.waitUploadFiles[0].index = that.waitUploadFiles[0].index + 1;
              that.waitUploadFiles[0].progress = progress;
            }
            that.upload();
          },
          error: function (err) {
            that.$Message.error('数据加载失败，请重试！');
            that.upload();
          }
        });
      }
    },
    format (fileName) {
      let type = 'ios-image';
      if(fileName && fileName !== '' && fileName != null && fileName !== 'null' && typeof fileName !== "undefined") {
        const format = fileName.split('.').pop().toLocaleLowerCase() || '';
        if (['gif','jpg','jpeg','png','bmp','webp'].indexOf(format) > -1) {
          type = 'ios-image';
        }
        else if (['mp4','m3u8','rmvb','avi','swf','3gp','mkv','flv'].indexOf(format) > -1) {
          type = 'ios-film';
        }
        else if (['mp3','wav','wma','ogg','aac','flac'].indexOf(format) > -1) {
          type = 'ios-musical-notes';
        }
        else if (['doc','docx'].indexOf(format) > -1) {
          type = 'md-document';
        }
        else if (['pdf'].indexOf(format) > -1) {
          type = 'ios-document';
        }
        else if (['numbers','csv','xls','xlsx'].indexOf(format) > -1) {
          type = 'ios-stats';
        }
        else if (['keynote','ppt','pptx'].indexOf(format) > -1) {
          type = 'ios-videocam';
        }
        else {
          type = 'ios-document-outline';
        }
      }
      return type;
    },
    jsonParamToFormData(json){
      let formdata = new FormData();
      let obj;
      for(let key in json) {
        obj = json[key];
        if(Array.isArray(obj) && obj) {
          if(obj.length === 0) {
            continue;
          }
          if(typeof obj[0] === 'object') {
            for(let i = 0; i < obj.length; i++) {
              for(let k in obj[i]) {
                formdata.append(key+'['+i+'].'+k, obj[i][k]);
              }
            }
          }
          else {
            formdata.append(key, json[key].toString());
          }
        }
        else {
          formdata.append(key, json[key]);
        }
      }
      return formdata;
    },
    uploadAfterLogic(file){
     

    }

  }
}
